import L from 'leaflet';
// Fix default markers in React Leaflet
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';

// Consistent zoom levels for points (fitBounds handles shapes)
export const getStandardZoomLevel = () => {
  const isMobile = window.innerWidth < 768;
  return isMobile ? 14 : 15;
};

// Configure default Leaflet marker icon
export const DefaultIcon = L.icon({
  iconUrl: icon,
  iconRetinaUrl: iconRetina,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});

// Apply the default icon globally
L.Marker.prototype.options.icon = DefaultIcon;